import {
    CREATE_CHECKING_DC_INWARD_MASTER_REQUEST,
    CREATE_CHECKING_DC_INWARD_MASTER_SUCCESS,
    CREATE_CHECKING_DC_INWARD_MASTER_FAILURE,
    DELETE_CHECKING_DC_INWARD_MASTER_REQUEST,
    DELETE_CHECKING_DC_INWARD_MASTER_SUCCESS,
    DELETE_CHECKING_DC_INWARD_MASTER_FAILURE,
    FETCH_SINGLE_CHECKING_DC_INWARD_MASTER_REQUEST,
    FETCH_SINGLE_CHECKING_DC_INWARD_MASTER_SUCCESS,
    FETCH_SINGLE_CHECKING_DC_INWARD_MASTER_FAILURE,
    FETCH_CHECKING_DC_INWARD_MASTER_REQUEST,
    FETCH_CHECKING_DC_INWARD_MASTER_SUCCESS,
    FETCH_CHECKING_DC_INWARD_MASTER_FAILURE,
    UPDATE_CHECKING_DC_INWARD_MASTER_REQUEST,
    UPDATE_CHECKING_DC_INWARD_MASTER_SUCCESS,
    UPDATE_CHECKING_DC_INWARD_MASTER_FAILURE,
    RESET_CHECKING_DC_INWARD_MASTER_INFO,
    CREATE_CHECKING_DC_INWARD_MASTER_FORM,
    UPDATE_CHECKING_DC_INWARD_MASTER_FORM,
    NAVIGATE_CHECKING_DC_INWARD_DETAILS,
    NAVIGATE_CHECKING_DC_INWARD_MASTER,
    FETCH_PENDING_CHECKING_PO_IN_INWARD_REQUEST,
    FETCH_PENDING_CHECKING_PO_IN_INWARD_SUCCESS,
    FETCH_PENDING_CHECKING_PO_IN_INWARD_FAILURE
} from './checkingDcInwardHeader.actionsType';

export const CHECKING_DC_INWARD_MASTER = 'checkingDcInwardHeader';

let initialState = {
    loading: false,
    checkingDcInwardHeader: [],
    pendingCheckingDc: [],
    checkingDcInwardHeaderForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: 0,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierName: '',
        fldDiscountValue: 0,
        fldItemsTotalValue: 0,
        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: 0
    },
    selectedState: {},
    errorMessage: '',
    singleCheckingDcInwardData: {},
    isCheckingDcInwardDetails: false
};

export let checkingDcInwardHeaderReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_CHECKING_DC_INWARD_MASTER_REQUEST:
        case FETCH_PENDING_CHECKING_PO_IN_INWARD_REQUEST:
        case CREATE_CHECKING_DC_INWARD_MASTER_REQUEST:
        case UPDATE_CHECKING_DC_INWARD_MASTER_REQUEST:
        case FETCH_SINGLE_CHECKING_DC_INWARD_MASTER_REQUEST:
        case DELETE_CHECKING_DC_INWARD_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_CHECKING_DC_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                checkingDcInwardHeader: updatePayload
            };
        case FETCH_PENDING_CHECKING_PO_IN_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                pendingCheckingDc: updatePayload
            };
        case CREATE_CHECKING_DC_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                checkingDcInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: 0
                }
            };
        case UPDATE_CHECKING_DC_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                checkingDcInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: 0
                }
            };
        case FETCH_SINGLE_CHECKING_DC_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                checkingDcInwardHeaderForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case DELETE_CHECKING_DC_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                checkingDcInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: 0
                }
            };
        case RESET_CHECKING_DC_INWARD_MASTER_INFO:
            return {
                ...state,
                checkingDcInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: 0
                }
            };
        case CREATE_CHECKING_DC_INWARD_MASTER_FORM:
        case UPDATE_CHECKING_DC_INWARD_MASTER_FORM:
            return {
                ...state,
                loading: false,
                checkingDcInwardHeaderForm: {
                    ...state.checkingDcInwardHeaderForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_CHECKING_DC_INWARD_MASTER_FAILURE:
        case FETCH_PENDING_CHECKING_PO_IN_INWARD_FAILURE:
        case CREATE_CHECKING_DC_INWARD_MASTER_FAILURE:
        case UPDATE_CHECKING_DC_INWARD_MASTER_FAILURE:
        case FETCH_SINGLE_CHECKING_DC_INWARD_MASTER_FAILURE:
        case DELETE_CHECKING_DC_INWARD_MASTER_FAILURE:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_CHECKING_DC_INWARD_DETAILS:
            return {
                ...state,
                isCheckingDcInwardDetails: true,
                singleCheckingDcInwardData: updatePayload.singleCheckingDcInwardData
            };
        case NAVIGATE_CHECKING_DC_INWARD_MASTER:
            return {
                ...state,
                isCheckingDcInwardDetails: false
            };
        default:
            return state;
    }
};
